// ============= Imports =============
import React from 'react';
import { Card, Headers, Spacer } from '@tw/tw-component-library';
import { FiTrash2 } from 'react-icons/fi';
import { CREATE_PROMPT_MESSAGES } from '@/constants/visualPrompts/createPromptMessages';
import { FeaturedStarButton } from '../FeaturedStarButton';
import { PROMPT_TYPE_LABELS } from '@/constants/visualPrompts/promptCategories';
import { VISUAL_PROMPT_MESSAGES } from '@/constants/visualPrompts/messages';
import { CardWrap, DeleteButton, StepCount, TitleRow } from './styles';
import type { VisualPromptCardProps } from './types';

// ============= Component =============
export const VisualPromptCard: React.FC<VisualPromptCardProps> = ({
  definition,
  onSelect,
  onDelete,
  onToggleFeatured,
}) => {
  const stepCount = definition.steps.filter((s) => s.type !== 'review').length;
  const typeLabel =
    PROMPT_TYPE_LABELS[definition.promptType] ?? definition.promptType;

  const isFeatured = definition.isFeatured === true;
  const showDelete = definition.isCustom && onDelete;

  return (
    <CardWrap>
      {showDelete && (
        <DeleteButton
          type="button"
          aria-label={CREATE_PROMPT_MESSAGES.deleteAriaLabel}
          onClick={(e) => {
            e.stopPropagation();
            onDelete(definition);
          }}
        >
          <FiTrash2 />
        </DeleteButton>
      )}
      <Card hover onClick={() => onSelect(definition)}>
      <TitleRow>
        {onToggleFeatured && (
          <FeaturedStarButton
            isFeatured={isFeatured}
            onToggle={() => onToggleFeatured(definition)}
          />
        )}
        <Headers headerType="h3">{definition.title}</Headers>
      </TitleRow>
      <Spacer />
      <p>{definition.description}</p>
      <StepCount>
        {definition.isCustom && <>Yours · </>}
        {typeLabel} · {stepCount} {VISUAL_PROMPT_MESSAGES.stepsLabel}
      </StepCount>
      </Card>
    </CardWrap>
  );
};
